var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.6875 14.25C6.72917 14.25 5.91667 13.9167 5.25 13.25C4.58333 12.5833 4.25 11.7708 4.25 10.8125V4.25C4.25 3.5625 4.49479 2.97396 4.98438 2.48438C5.47396 1.99479 6.0625 1.75 6.75 1.75C7.4375 1.75 8.02604 1.99479 8.51562 2.48438C9.00521 2.97396 9.25 3.5625 9.25 4.25V9.25H8.3125V4.25C8.3125 3.8125 8.16146 3.44271 7.85938 3.14062C7.55729 2.83854 7.1875 2.6875 6.75 2.6875C6.3125 2.6875 5.94271 2.83854 5.64062 3.14062C5.33854 3.44271 5.1875 3.8125 5.1875 4.25V10.8125C5.1875 11.5 5.43229 12.0885 5.92188 12.5781C6.41146 13.0677 7 13.3125 7.6875 13.3125C7.98958 13.3125 8.27344 13.263 8.53906 13.1641C8.80469 13.0651 9.04167 12.9271 9.25 12.75V13.875C9.01042 13.9896 8.76042 14.0807 8.5 14.1484C8.23958 14.2161 7.96875 14.25 7.6875 14.25ZM10.5 13.625V11.75H8.625V10.5H10.5V8.625H11.75V10.5H13.625V11.75H11.75V13.625H10.5ZM7.6875 10.8125V11.75C7.25 11.75 6.88021 11.599 6.57812 11.2969C6.27604 10.9948 6.125 10.625 6.125 10.1875V4.25H7.0625V10.1875C7.0625 10.3646 7.1224 10.513 7.24219 10.6328C7.36198 10.7526 7.51042 10.8125 7.6875 10.8125ZM10.1875 7.375V4.25H11.125V7.375H10.1875Z",
    fill: "#27AE60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddContact);
export default __webpack_public_path__ + "static/media/icon-add-contact.2161a598eb4a977679e41163123acc21.svg";
export { ForwardRef as ReactComponent };